const mapChart = function(model){
    var result = []
  
    model.forEach((element, index) => {
        let itm = {
            colors: [
                "#003e51",
                "#d1b9a7",
                "#0c7ba1",
                "#95c6d5",
                "#9350d7",
                "#1d3a94",
                "#aabcf4",
                "#058262",
                "#fcab7c",
                "#800061",
            ],
            chart:{
                type: element.chartType,
                transpose: true
            },
            title: {
                text: element.dashboardName,
                align: 'left'
            },
            xAxis: {
                categories: Object.entries(element.values).map(([name]) => (name)),
                labels: {
                    formatter: function() {
                        if (element.chartType === 'pie' && element.drillDown && element.drillDown[this.value] && element.drillDown[this.value].length > 0) {
                            return '<a href="#">' + this.value + '</a>';
                        } else {
                            return this.value;
                        }
                    }
                }
            },
            tooltip: {
                formatter: function() {
                  var percentage = (this.y / this.series.yData.reduce((a, b) => a + b, 0)) * 100;
                  return '<b>' + this.series.name + '</b>: ' + this.y + ' (' + percentage.toFixed(2) + '%)';
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {   
                        format: '<b>{point.name}</b>: {point.y} '
                    },
                    events: {
                        legendItemClick: function () {
                            var points = this.points;
        
                            for (var i = 0; i < points.length; i++) {
                                var point = points[i];
        
                                if (point.y === 0) {
                                    point.setVisible(!point.visible, false);
                                }
                            }
        
                            return false;
                        }
                    },
                    showInLegend: true,
                    ignoreHiddenPoint: true,
                },
                column: {
                    dataLabels: {
                        enabled: true,
                        color: '#FFFFFF',
                        align: 'center',
                        verticalAlign: 'top',
                        formatter: function() {
                          return this.y;
                        }
                    },
                    stacking: 'normal',
                    ignoreHiddenPoint: true,
                    showInLegend: false,
                }
            },
            legend: {
                enabled: true,
                labelFormatter: function() {
                  return this.name + ': ' + this.y;
                }
            },
            series: [{
                name: element.dashboardName,
                innerSize: '67%',
                colorByPoint: true,
               
                dataLabels: {
                    enabled: true,
                    borderRadius: '2px',
                    color:'black',
                    align: 'center',
                    verticalAlign: 'top',
                    formatter: function() {
                      return element.chartType === 'column' ? this.y : null;
                    }
                },
                data:Object.entries(element.values).map(([name, y]) => ({ name, y, drilldown: element.chartType === 'pie' && element.drillDown ? name : undefined }))
            }],
            drilldown: {
                series: element.drillDown ? Object.entries(element.drillDown).map(([name, y]) => ({ name, id: name, data: y.map(z => Object.entries(z)[0]), 
                    innerSize: '67%',
                    dataLabels: {
                        enabled: true,
                        borderRadius: '2px',
                        color:'black',
                        align: 'center',
                        verticalAlign: 'top',
                        formatter: function() {
                          return element.chartType === 'column' ? this.y : null;
                        }
                    }

                })) : []
            }
        }
  
        result.push(itm)
        console.log(itm)
    });
  
    return result;
  }
  
  export default {mapChart}
  